import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { GridCommentCell } from 'components/shared'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface CommentCellProps {
  params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
  densityStyles: DensityStyleTypes
  route?: string
  handleRowClick?: (row: GridRenderCellParams, pathPrefix?: string) => void
}

const CommentCell: FC<CommentCellProps> = ({ params, densityStyles, route, handleRowClick }) => {
  return (
    <GridCommentCell
      params={params}
      densityStyles={densityStyles}
      boardTheme="icon.mtb"
      route={route}
      routeConfig={{ basePath: '/mtb', childQueryParam: 'task' }}
      handleRowClick={handleRowClick}
      countField="commentCount"
    />
  )
}

export default CommentCell
